import { Component, Input, ElementRef, ViewChild, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-iframe-viewer',
  templateUrl: './iframe-viewer.component.html',
  styleUrls: ['./iframe-viewer.component.css'],
})
export class IframeViewerComponent implements OnInit {
  @Input() url: string;
  @Input() width: number;
  @Input() height: number;
  @Input() widthUnit: string = 'px';
  @Input() heightUnit: string = 'px';
  @Input() visible: boolean = true;

  public internalURL: SafeResourceUrl;

  @ViewChild('iframe') iframe: ElementRef<HTMLIFrameElement>;



  ngOnInit(): void {
    this.internalURL = this.getSafeUrl(this.url);

  }

  constructor(private sanitizer: DomSanitizer) {}

  getSafeUrl(url: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  refresh() {
    if (this.iframe) {
      console.log('Refrescando iframe');
      const iframeElement = this.iframe.nativeElement;
      const src = iframeElement.src;
      iframeElement.src = ''; // Quitar la URL para forzar el refresco
      setTimeout(() => {
        iframeElement.src = src; // Volver a poner la URL para que se refresque el iframe
      }, 0);
    }
  }
}
